export const hebTranslation = {
    'music': 'מוזיקה',
    'local art craft': 'יצירה מקומית',
    'food': 'אוכל',
    'lectures': 'הרצאות',
    'fun': 'כיף',
    'kids': 'ילדים',
    'teenagers': 'בני נוער',
    'adults': 'מבוגרים',
    'family': 'משפחה',
    'women': 'נשים'
}